export enum UserRoles {
  Superadmin = 'Superadministrators',
  Admin = 'Administrators',
  Program_coordinator = 'Programmas koordinators',
  Partner_coordinator = 'Partneru koordinators',
  Content_redactor = 'Satura redaktors',
}
